var map = {
  "./cs.json": [
    "EQO",
    [
      "m0"
    ]
  ],
  "./en.json": [
    "gd",
    [
      "qu"
    ]
  ],
  "./pl.json": [
    "uFV",
    [
      "sr"
    ]
  ],
  "./ru.json": [
    "lFE",
    [
      "rn"
    ]
  ],
  "./tr.json": [
    "URR",
    [
      "6n"
    ]
  ],
  "./ja.json": [
    "uj9",
    [
      "gs1"
    ]
  ],
  "./zh.json": [
    "wT1",
    [
      "2w"
    ]
  ],
  "./pt-br.json": [
    "nw",
    [
      "taz"
    ]
  ],
  "./de.json": [
    "ZAK",
    [
      "75a"
    ]
  ],
  "./es.json": [
    "WU",
    [
      "4rz"
    ]
  ],
  "./fr.json": [
    "Bf",
    [
      "ve"
    ]
  ],
  "./it.json": [
    "oC",
    [
      "yd6"
    ]
  ],
  "./ko.json": [
    "Md",
    [
      "qc5"
    ]
  ],
  "./pt.json": [
    "Hu",
    [
      "x6"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Xr";
module.exports = __rspack_async_context;
